import styled from 'styled-components';
import { mq } from 'stylesheets/utils';
export const List = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  width: 100%;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  margin-bottom: 14px;
`;

export const ListHeader = styled.div`
  background-color: ${({ theme }) => theme.colors.innerProduct.gray};
  padding: 0 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 50px;
  ${mq(576)} {
    padding: 0 8px;
  }
`;

export const P = styled.p`
  color: ${({ theme }) => theme.colors.black2};
  font-size: ${({ theme }) => theme.fontsizes.body16};
  font-weight: ${({ theme }) => theme.fontWeight.font400};
`;

export const Div = styled.div`
  display: flex;
  align-items: center;
`;

export const CarImage = styled.div`
  width: 70px;
  height: 50px;
`;

export const ListContent = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.innerProduct.lightGray};
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  padding: 18px 28px;
`;
